_ = require('lodash')

module.exports = () ->
  return {
    restrict: 'A'
    replace: true
    scope:
      facet: '='
      include: '=?'
      exclude: '=?'
      label: '@'
      onchange: '=?msfChange'
      hideSourceCount: '=?'
      selectionEnabled: '=?msfSelectionEnabled'

    controller: ($scope, $log, $timeout) ->
      $scope.debug = (args...) ->
        # $log.debug('MultiSelectFacet', $scope, ':', args...)

      ############
      # SCOPE
      ############

      # Make sure we have sensible defaults
      if not angular.isDefined($scope.selectionEnabled)
        $scope.selectionEnabled = true

      $scope.facet = $scope.facet || []
      $scope.include = $scope.include || []
      $scope.exclude = $scope.exclude || []
      $scope.label = $scope.label || 'item'
      $scope.onchange = $scope.onchange || () ->
      ############
      # SELECTION
      ############

      getChildren = (parentId) ->
        return _.chain($scope.facet)
          .filter((item) ->
            item.parent == parentId
        )
          .map((item) -> item.id)
          .value()

      areAllSubitemsSelected = (parentId) ->
        children = getChildren(parentId)
        if $scope.isInIncludeMode()
          return children.every((item) -> $scope.include.includes(item))
        else if $scope.isInExcludeMode()
          return !children.some((item) -> $scope.exclude.includes(item))

      allChildrenSelected = (item) ->
        return item.parent && areAllSubitemsSelected(item.parent)

      $scope.toggle = (item) ->
        $scope.debug('Toggling', item)
        if $scope.isSelected(item)
          $scope.deselect(item)
        else
          $scope.select(item)

      $scope.deselect = (item) ->
        $scope.debug('Deselecting', item)

        children = getChildren(item.id)

        if $scope.isInIncludeMode()
          $scope.removeItem($scope.include, item.id)
          if item.parent
            $scope.removeItem($scope.include, item.parent)
          else
            children.forEach((childId) ->
              $scope.removeItem($scope.include, childId)
            )
        else
          $scope.addItem($scope.exclude, item.id)
          if item.parent
            $scope.addItem($scope.exclude, item.parent)
          else
            children.forEach((childId) ->
              $scope.addItem($scope.exclude, childId)
            )

        return $scope.onchange()

      $scope.select = (item) ->
        $scope.debug('Selecting', item)

        children = getChildren(item.id)

        if $scope.isInIncludeMode()
          $scope.addItem($scope.include, item.id)
          if allChildrenSelected(item)
            $scope.addItem($scope.include, item.parent)
          if !item.parent
            children.forEach((childId) -> $scope.addItem($scope.include, childId))
        else if $scope.isInExcludeMode()
          $scope.removeItem($scope.exclude, item.id)
          if allChildrenSelected(item)
            $scope.removeItem($scope.exclude, item.parent)
          if !item.parent
            children.forEach(
              (childId) ->
                $scope.removeItem($scope.exclude, childId)
            )

        return $scope.onchange()

      $scope.selectAll = () ->
        $scope.include.length = 0
        $scope.exclude.length = 0
        return $scope.onchange()

      $scope.selectOne = (item) ->
        $scope.debug('Selecting exclusively', item)
        $scope.exclude.splice(0, $scope.exclude.length)
        $scope.include.splice(0, $scope.include.length)
        $scope.include.push(item.id)
        if item.parent && getChildren(item.parent).length == 1
          $scope.include.push(item.parent)
        if !item.parent
          getChildren(item.id).forEach((childId) ->
            $scope.include.push(childId)
          )
        return $scope.onchange()

      $scope.removeItem = (arr, id) ->
        index = arr.indexOf(id)
        if index >= 0
          arr.splice(index, 1)

      $scope.addItem = (arr, id) ->
        index = arr.indexOf(id)
        if index < 0
          arr.push(id)

      $scope.isSelected = (item) ->
        $scope.debug('Checking for', item)
        if $scope.isInIncludeMode()
          return item.id in $scope.include
        else if $scope.isInExcludeMode()
          return item.id not in $scope.exclude
        else if $scope.isInSelectAllMode()
          return true

      $scope.shouldShowSourceCounts = ( only ) ->
        if $scope.hideSourceCount
          return false
        return !$scope.selectionEnabled || !only

      $scope.rootFilter = ( item ) ->
        return !item.parent

      $scope.parentFilter = ( parentId ) -> ( item ) ->
        return item.parent == parentId

      ##########
      # STATES
      ##########
      #
      # The three states we can be in.  Either we are explicitely
      # excluding items, explicitely including items, or we just want
      # everything.
      #

      $scope.isInIncludeMode = () ->
        return $scope.include.length > 0

      $scope.isInExcludeMode = () ->
        return $scope.exclude.length > 0

      $scope.isInSelectAllMode = () ->
        return not $scope.isInExcludeMode() and not $scope.isInIncludeMode()

    template: require('./multi-select-facet.html')
  }
